module.exports = __webpack_public_path__ + "img/DE00938.10e5479e.png";